module.exports = __webpack_public_path__ + "static/media/porzio_global_spend_transparency_logo.461253c6.png";